
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"26","viewBox":"0 0 21 29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_199_34)"}},[_c('rect',{attrs:{"x":"17","y":"3","width":"21","height":"13","rx":"2.5","transform":"rotate(90 17 3)","fill":"#fff"}}),_c('rect',{attrs:{"x":"16.5","y":"3.5","width":"20","height":"12","rx":"2","transform":"rotate(90 16.5 3.5)"}})]),_c('path',{attrs:{"d":"M8 5.5h5"}}),_c('circle',{attrs:{"cx":"10.5","cy":"21","r":"1","fill":"#C4C4C4"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_199_34","x":"0","y":"0","width":"21","height":"29","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"1"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"2"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_199_34"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_199_34","result":"shape"}})])])])
          )
        }
      }
    